
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_REGISTER_REQUEST = 'AUTH_REGISTER_REQUEST';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';

export const AUTH_RESET_REQUEST = 'AUTH_RESET_REQUEST';
export const AUTH_RESET_SUCCESS = 'AUTH_RESET_SUCCESS';
export const AUTH_RESET_FAILURE = 'AUTH_RESET_FAILURE';

export const AUTH_RESET_ACTIVATION_CODE_REQUEST = 'AUTH_RESET_ACTIVATION_CODE_REQUEST';
export const AUTH_RESET_ACTIVATION_CODE_SUCCESS = 'AUTH_RESET_ACTIVATION_CODE_SUCCESS';
export const AUTH_RESET_ACTIVATION_CODE_FAILURE = 'AUTH_RESET_ACTIVATION_CODE_FAILURE';

export const AUTH_SIGNOUT_SUCCESS = 'AUTH_SIGNOUT_SUCCESS';
export const AUTH_SIGNOUT_FAILURE = 'AUTH_SIGNOUT_FAILURE';
export const AUTH_AUTHORIZED = 'AUTH_AUTHORIZED';
export const AUTH_CONNECTED_USER = 'AUTH_CONNECTED_USER';
export const AUTH_CONNECTED_ACCOUNT = 'AUTH_CONNECTED_ACCOUNT';




// WEBPACK FOOTER //
// ./src/data/auth/types.js